module.exports = __webpack_public_path__ + "5e83ecba2d6938afcc05b8d4aafb09ea.woff";